<template>
  <div class="app-container" v-show="isLogin">
    <!-- 订单记录 -->
    <div style="color: black; text-align: left">
      <div class="filter-container" style="margin-bottom: 10px">
        &nbsp;&nbsp;&nbsp;&nbsp;成交时间：
        <el-date-picker
          v-model="startDate"
          type="datetime"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="起始时间"
          :picker-options="pickerOptionsStart"
        ></el-date-picker>
        <span class="el-range-separator">至</span>
        <el-date-picker
          v-model="endDate"
          type="datetime"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="结束时间"
          :picker-options="pickerOptionsEnd"
        ></el-date-picker>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;订单号：<el-input
          v-model="listQuery.order"
          style="width: 13vw"
          class="filter-item"
          @keyup.enter.native="handleFilter"
          clearable
        />&nbsp;&nbsp;&nbsp;&nbsp;
        <el-button
          type="primary"
          style="
            font-size: 12px;
            background-color: #0850fc;
            color: white;
            height: 34px;
            border-radius: 0.5em;
            padding: 10px 12px;
          "
          @click="handleFilter"
          >查询</el-button
        >
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;点数：<span>{{ points }}</span>
        <el-table
          v-loading="listLoading"
          :data="list"
          highlight-current-row
          style="color: rgb(70, 70, 70); margin-top: 10px; width: 1000px"
          :row-style="{ height: '0' }"
          :cell-style="{ padding: '3px 0' }"
          :header-cell-style="{
            background: 'rgb(247 248 252) !important',
            color: '#ededed  !important',
            padding: '7px 0',
            color: 'rgb(140, 140, 140)',
          }"
        >
          <el-table-column label="操作时间" align="left" min-width="2">
            <template slot-scope="{ row }">
              <span>{{ row.created_at }}</span>
            </template>
          </el-table-column>

          <el-table-column label="订单编号" min-width="6" align="left">
            <template slot-scope="{ row }">
              <span>{{ row.order_no }}</span>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="listQuery.page"
          layout="total, prev, pager, next"
          style="padding-top: 12px; padding-bottom: 0px; text-align: left"
          @pagination="getList"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { DatePicker } from "element-ui";
import axios from "axios";
import Cookies from "js-cookie";
import waves from "@/directive/waves"; // waves directive
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination

export default {
  name: "wllog",
  components: {
    Pagination,
    "el-date-picker": DatePicker,
  },
  directives: { waves },
  data() {
    return {
      isLogin: false,
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        perPage: 20,
        date_one: this.startDate,
        date_two: this.endDate,
        order: "",
      },
      startDate: "",
      endDate: "",

      pickerOptionsStart: {
        disabledDate: (time) => {
          let endDateVal = this.endDate;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime(); //选则的时间
          }
        },
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.startDate;
          if (beginDateVal) {
            return time.getTime() < new Date(beginDateVal).getTime();
          }
        },
      },
      points: "",
    };
  },
  created() {
    //判断 登录userToken是否有效 userToken == '' ||
    const userToken = Cookies.get("view_userToken");

    if (userToken == undefined) {
      this.isLogin = false;
      this.$confirm("请先登录再使用！", "提示", {
        confirmButtonText: "确定",
      })
        .then(() => {
          // 重新导航到登录页面
          localStorage.clear();
          this.$root.removeCookies();
          this.$router.push({ path: "/login" });
        })
        .catch(() => {
          // 重新导航到首页
          localStorage.clear();
          this.$root.removeCookies();
          this.$router.push({ path: "/" });
        });
      return;
    } else {
      this.isLogin = true;
    }
    this.getList();
    this.$root.getUserInfo();
    const points = Cookies.get("view_points");
    this.points = points;
  },
  methods: {
    async getList() {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        this.isLogin = false;
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return;
      }

      this.list = [];
      if (this.startDate == "") {
        this.listQuery.date_one = "2022-12-01 00:00:00";
        this.startDate = "2022-12-01 00:00:00";
      } else {
        this.listQuery.date_one = this.startDate;
      }
      if (this.endDate == "") {
        this.listQuery.date_two = new Date().toLocaleString();
        this.endDate = new Date().toLocaleString();
      } else {
        this.listQuery.date_two = this.endDate;
      }

      this.listLoading = true;
      const url = this.$root.commonPreUrl + "/index/wuliuLog";
      const token = Cookies.get("view_userToken");
      const res = axios.get(url, {
        headers: {
          Authorization: "Bearer " + token,
        },
        params: this.listQuery,
      });
      res
        .then((response) => {
          const resd = response.data;
          // if (resd.data.length > 0) {
          if (resd.code == "200") {
            this.list = resd.data.data;
            this.total = resd.data.total;
            this.listLoading = false;
          }
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          if (
            JSON.stringify(error).includes("Error: Request failed with status code 401")
          ) {
            this.$confirm("登录信息已失效，请重新登录!", "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => {
                // 重新导航到首页
                localStorage.clear();
                this.$root.removeCookies();
                this.$router.push({ path: "/login" });
              })
              .catch(() => {});
          }

          return;
        });
      // Just to simulate the time of the request
      setTimeout(() => {
        this.listLoading = false;
      }, 3 * 1000);
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
  },
};
</script>

<style>
@import "vue2-datepicker/index.css";

.spanColors {
  /* color: #409eff; */
  font-weight: bold;
  border-top: rgb(221, 221, 221) 1px solid;
  border-right: rgb(221, 221, 221) 1px solid;
  border-left: rgb(221, 221, 221) 1px solid;
  border-bottom: white 2px solid;
  border-top-left-radius: 0.3em;
  border-top-right-radius: 0.3em;
}
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  display: inline-block;
  max-width: 87%;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/views/cwmx/wllog/index.vue